type ComponentRuntimeGlobal = typeof globalThis & {
    __secureblobComponentJobRuntimeEnv?: Record<string, string | undefined>
    process?: { env?: Record<string, string | undefined> }
}

function getRuntimeGlobal(): ComponentRuntimeGlobal {
    return globalThis as ComponentRuntimeGlobal
}

export function hasSecureBlobComponentJobRuntimeEnv(): boolean {
    const env = getRuntimeGlobal().__secureblobComponentJobRuntimeEnv
    return env != null && typeof env === 'object'
}

export function readSecureBlobRuntimeEnv(name: string): string | undefined {
    const runtimeGlobal = getRuntimeGlobal()
    return runtimeGlobal.__secureblobComponentJobRuntimeEnv?.[name]
        ?? runtimeGlobal.process?.env?.[name]
}

export function emitSecureBlobComponentProgress(
    stage: string,
    message: string,
    details?: Record<string, unknown>,
): void {
    if (!hasSecureBlobComponentJobRuntimeEnv()) {
        return
    }

    try {
        const payload: Record<string, unknown> = { stage, message }
        if (details != null) {
            payload.details = details
        }
        console.log(`SECUREBLOB_PROGRESS ${JSON.stringify(payload, (_key, value) =>
            typeof value === 'bigint' ? value.toString() : value
        )}`)
    } catch {
        // Progress must never affect component job execution.
    }
}
